import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, typography, shape, palette }) => ({
  container: {
    whiteSpace: 'nowrap',
  },
}));
